





















































import { Component, Vue } from "vue-property-decorator";
import Game from "./Game.vue";
import { LoadFromJson, LoadFromJsonType } from "../store";

@Component({
  components: { Game },
})
export default class Wrapper extends Vue {
  modalShow = false;
  loadType = LoadFromJsonType.load;
  stopMove = "";
  text = "";
  replayData: { stard: number; end: number; current: number } | null = null;

  handleOK() {
    this.$store.dispatch("loadFromJSON", {
      engineData: JSON.parse(this.text),
      type: this.loadType,
      stopMove: this.stopMove
    } as LoadFromJson);
  }

  openExport() {
    this.text = JSON.stringify(this.$store.state.data);
    this.modalShow = true;
  }

  startReplay() {
    this.$store.dispatch("replayStart");
  }

  replayTo(dest: number) {
    this.$store.dispatch("replayTo", dest);
  }

  endReplay() {
    this.$store.dispatch("replayEnd");
    this.replayData = null;
  }

  mounted() {
    const unsub = this.$store.subscribeAction(({ type, payload }) => {
      if (type === "replayInfo") {
        this.replayData = payload;
      }
    });
    this.$on("hook:beforeDestroy", unsub);
  }
}
